import { MDCSnackbar } from '@material/snackbar';

const props = {
    snackbarObject: null
};

export const snackbarModel = {
    content: '',
    actionButtonText: '',
    onAction: null,
    theme: 'default', // Options: default, error, warning
    remain: false
};

export function initSnackbar() {
    const snackbarElm = document.getElementById('mdc-snackbar');
    const snackbar = new MDCSnackbar(snackbarElm);

    props.snackbarObject = snackbar;

    snackbar.listen('MDCSnackbar:closed', () => {
        if (!$('#mdc-snackbar').hasClass('mdc-snackbar--remain'))
            mapSnackbar({ ...snackbarModel });
    });
}

export function openSnackbar(model) {
    const snackbar = props.snackbarObject;
    if (snackbar) {
        mapSnackbar(model);
        snackbar.open();
    }
}

export function bindCloseRemainSnackbar(snackbar) {
    $('.mdc-snackbar--remain .mdc-snackbar__dismiss').off('click').on('click', function () {
        snackbar.open();
        $('.mdc-snackbar--remain').removeClass('mdc-snackbar--remain');
        snackbar.close();
    });
}

export function mapSnackbar(model) {
    const snackbar = $('#mdc-snackbar');

    // Set theme
    snackbar.attr('data-mdc-snackbar-theme', model.theme);

    // Set snackbar content and button text
    snackbar.find('.mdc-snackbar__label').text(model.content);
    snackbar.find('.mdc-snackbar__action').text(model.actionButtonText);

    // If an action has been set, bind and show the action button
    if (model.onAction)
        snackbar.find('.mdc-snackbar__action').removeClass('d-none').off('click').on('click', () => model.onAction());
    else
        snackbar.find('.mdc-snackbar__action').addClass('d-none').off('click');

    // If the snackbar is set to remain on the page, bind close event to dismiss button.
    if (model.remain) {
        snackbar.addClass('mdc-snackbar--remain');
        bindCloseRemainSnackbar(props.snackbarObject);
    }
    else {
        snackbar.removeClass('mdc-snackbar--remain');
        $('.mdc-snackbar__dismiss').off('click');
    }

    // If the snackbar content is over 100 characters, stack it.
    if (model.content.length > 100)
        snackbar.addClass('mdc-snackbar--stacked');
    else
        snackbar.removeClass('mdc-snackbar--stacked');

    // If the snackbar is already open and we open another, update and shake it.
    snackbar.removeClass('mdc-snackbar--shake');

    if (snackbar.hasClass('mdc-snackbar--open')) {
        setTimeout(() => {
            snackbar.addClass('mdc-snackbar--shake');
        }, 100);
    }
}